<template>
  <svg width="20"
       height="19"
       viewBox="0 0 20 19"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M9.99121 18.7422C14.9746 18.7422 19.0879 14.6289 19.0879 9.6543C19.0879 4.67969 14.9658 0.566406 9.98242 0.566406C5.00781 0.566406 0.90332 4.67969 0.90332 9.6543C0.90332 14.6289 5.0166 18.7422 9.99121 18.7422ZM9.99121 16.9316C5.95703 16.9316 2.73145 13.6885 2.73145 9.6543C2.73145 5.62012 5.95703 2.38574 9.98242 2.38574C14.0166 2.38574 17.2598 5.62012 17.2686 9.6543C17.2773 13.6885 14.0254 16.9316 9.99121 16.9316ZM9.98242 14.5938C10.2109 14.5938 10.3867 14.4268 10.3867 14.1895V13.6006C11.8105 13.4688 12.8828 12.6514 12.8828 11.3154C12.8828 10.1201 12.1094 9.41699 10.5801 9.13574L10.3867 9.0918V6.91211C10.9492 7.00879 11.3359 7.34277 11.5029 7.86133C11.6348 8.15137 11.8193 8.31836 12.1357 8.31836C12.4873 8.31836 12.7334 8.08105 12.7334 7.74707C12.7334 7.6416 12.707 7.54492 12.6895 7.43945C12.4521 6.53418 11.5645 5.88379 10.3867 5.76074V5.17188C10.3867 4.93457 10.2109 4.76758 9.98242 4.76758C9.75391 4.76758 9.58691 4.93457 9.58691 5.17188V5.76074C8.19824 5.90137 7.21387 6.74512 7.21387 7.9668C7.21387 9.10938 7.97852 9.77734 9.4375 10.1113L9.58691 10.1465V12.4668C8.875 12.3613 8.46191 11.9834 8.32129 11.4648C8.19824 11.1484 7.99609 10.9902 7.69727 10.9902C7.32812 10.9902 7.09082 11.2363 7.09082 11.5879C7.09082 11.6846 7.11719 11.7812 7.14355 11.8955C7.39844 12.8271 8.33008 13.4775 9.58691 13.5918V14.1895C9.58691 14.4355 9.75391 14.5938 9.98242 14.5938ZM9.58691 8.88965L9.52539 8.87207C8.82227 8.66992 8.49707 8.3623 8.49707 7.8877C8.49707 7.4043 8.91016 7.00879 9.58691 6.90332V8.88965ZM10.3867 10.3486L10.5537 10.3838C11.3184 10.5947 11.5908 10.9111 11.5908 11.4121C11.5908 11.9658 11.1865 12.3701 10.3867 12.4668V10.3486Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'SalesIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
